var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6723 0.000976562H11.3276C5.35718 0.000976562 0.5 4.85815 0.5 10.8286V29.1736C0.5 35.1437 5.35718 40.0009 11.3276 40.0009H29.6726C35.6427 40.0009 40.4999 35.1437 40.4999 29.1736V10.8286C40.4999 4.85815 35.6427 0.000976562 29.6723 0.000976562ZM38.1549 29.1736C38.1549 33.8507 34.3497 37.6559 29.6723 37.6559H11.3276C6.65022 37.6559 2.845 33.8507 2.845 29.1736V10.8286C2.845 6.1512 6.65022 2.34597 11.3276 2.34597H29.6726C34.3497 2.34597 38.1549 6.1512 38.1549 10.8286V29.1736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4999 9.06398C14.4691 9.06398 9.56274 13.9702 9.56274 20.0012C9.56274 26.0321 14.469 30.9384 20.4999 30.9384C26.5309 30.9384 31.4371 26.0321 31.4371 20.0012C31.4371 13.9702 26.5309 9.06398 20.4999 9.06398ZM20.4999 28.5934C15.7624 28.5934 11.9077 24.7391 11.9077 20.0012C11.9077 15.2637 15.7624 11.409 20.4999 11.409C25.2378 11.409 29.0921 15.2637 29.0921 20.0012C29.0921 24.7391 25.2378 28.5934 20.4999 28.5934ZM31.6987 5.17969C29.9164 5.17969 28.4669 6.62961 28.4669 8.41148C28.4669 10.1937 29.9164 11.6436 31.6987 11.6436C33.4809 11.6436 34.9307 10.1937 34.9307 8.41156C34.9307 6.62937 33.4809 5.17969 31.6987 5.17969ZM31.6987 9.29836C31.2098 9.29836 30.8118 8.90039 30.8118 8.41148C30.8118 7.92234 31.2098 7.52469 31.6987 7.52469C32.1878 7.52469 32.5858 7.92234 32.5858 8.41148C32.5858 8.90039 32.1878 9.29836 31.6987 9.29836Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.abba5183734a79cb38940cacd677144a.svg";
export { ForwardRef as ReactComponent };